export default {
  tabs: {
    detailed: {
      notes:
        'Tab title for the detailed property comparison in the selection details pane',
      message: 'Detailed',
    },
    bom: {
      notes: 'Tab title for the bill of material in the selection details pane',
      message: 'BOM',
    },
    actions: {
      notes: 'Tab title for the planned actions in the selection details pane',
      message: 'Actions',
    },
  },
  viewingAll: {
    detailed: {
      notes:
        'Shown above the detailed tab in the selection details pane when no panels are selected',
      message: 'All detailed',
    },
    bom: {
      notes:
        'Shown above the BOM tab in the selection details pane when no panels are selected',
      message: 'All BOM',
    },
    actions: {
      notes:
        'Shown above the actions tab in the selection details pane when no panels are selected',
      message: 'All actions',
    },
  },
  propertyColumn: {
    notes: 'Column header for the property name in the selection details table',
    message: 'Property',
  },
  valueColumn: {
    notes:
      'Column header for the property value in the selection details table',
    message: 'Value',
  },
  stateColumn: {
    notes: 'Column header for the change state in the selection details table',
    message: 'State',
  },
  editActions: {
    selectMedia: {
      notes:
        'Option in the value edit dropdown that opens the screening media selection dialog',
      message: 'Select screening media...',
    },
    revert: {
      notes:
        'Option in the value edit dropdown that reverts the screening media of the selected panels',
      message: 'Revert',
    },
  },
  changed: {
    notes:
      'Shown in the state column when a property differs from the compared panels',
    message: 'Changed',
  },
  unchanged: {
    notes:
      'Shown in the state column when a property matches the compared panels',
    message: 'Unchanged',
  },
};
